export default __webpack_public_path__ + "static/media/BD.75e52765.jpg";